module.exports = __webpack_public_path__ + "static/donate-1f4a341a1045d09d07a5f996ebb40eaa.svg";